var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLug = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 70,
  height: 70,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EBEBEB",
  d: "M35 70c19.33 0 35-15.67 35-35S54.33 0 35 0 0 15.67 0 35s15.67 35 35 35"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0E2240",
  d: "m14.416 46.332 1.281-3.374 7.102-.349c0 1.493-.389 2.237-1.88 2.237zM14.416 24.227l1.281 3.374 7.102.349c0-1.492-.389-2.237-1.88-2.237zM18.843 29.74c.521 1.82.777 3.706.762 5.6.03 1.877-.204 3.749-.696 5.56q-.166.51-.385 1l32.854-.142a1.48 1.48 0 0 0 1.256-.682l3.226-5.014a1.48 1.48 0 0 0 .014-1.582l-3.14-5.067a1.47 1.47 0 0 0-1.248-.698l-32.97.144c.109.3.234.57.327.88m23.08 4.076a1.416 1.416 0 1 1-.996.426 1.42 1.42 0 0 1 .995-.429zm-4.846.065a1.417 1.417 0 1 1-1.296.89 1.42 1.42 0 0 1 1.296-.895zm-4.845.064a1.417 1.417 0 1 1-1.296.89 1.42 1.42 0 0 1 1.297-.895z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ADADAD",
  d: "m16.732 21.908-1.144 1.143-3.723-3.714-3.722 3.714L7 21.908l4.865-4.866z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ADADAD",
  d: "M12.615 18.05v19.418h-1.5V18.05zM16.732 49.193l-1.144-1.143-3.722 3.715-3.723-3.715L7 49.193l4.866 4.866z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ADADAD",
  d: "M12.615 33.467v19.585h-1.5V33.467zM63.623 28.497 62.48 29.64l-3.723-3.714-3.722 3.714-1.144-1.143 4.866-4.867z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ADADAD",
  d: "M59.507 24.639v15.004h-1.5V24.639zM63.623 41.778l-1.143-1.143-3.722 3.715-3.723-3.715-1.144 1.143 4.867 4.866z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ADADAD",
  d: "M59.507 30.632v15.004h-1.5V30.632z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h70v70H0z"
})))));
export { SvgLug as ReactComponent };
export default "/_next/static/images/lug.svg";